var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.33333C1 4.46649 1 3.53307 1.36331 2.82003C1.68289 2.19282 2.19282 1.68289 2.82003 1.36331C3.53307 1 4.46649 1 6.33333 1H15.6667C17.5335 1 18.4669 1 19.18 1.36331C19.8072 1.68289 20.3171 2.19282 20.6367 2.82003C21 3.53307 21 4.46649 21 6.33333V15.6667C21 17.5335 21 18.4669 20.6367 19.18C20.3171 19.8072 19.8072 20.3171 19.18 20.6367C18.4669 21 17.5335 21 15.6667 21H6.33333C4.46649 21 3.53307 21 2.82003 20.6367C2.19282 20.3171 1.68289 19.8072 1.36331 19.18C1 18.4669 1 17.5335 1 15.6667V6.33333Z",
    stroke: "#BD23DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNews);
export default __webpack_public_path__ + "static/media/new_news.5cd144c8cfb4876464271b8d7b8fc682.svg";
export { ForwardRef as ReactComponent };